import { Table, Text } from '@radix-ui/themes'
import type { TRPCOutputs } from '~/utils/trpc'

type Installation = TRPCOutputs['ops']['stationInstallations']['list'][number]

// The leading ID / Site / Station columns are shared by every installation view, so a row
// stays recognisable when switching between them. Kept in one place so the three tables
// cannot drift apart.
export const InstallationIdentityHeaders = () => (
  <>
    <Table.ColumnHeaderCell>ID</Table.ColumnHeaderCell>
    <Table.ColumnHeaderCell>Site</Table.ColumnHeaderCell>
    <Table.ColumnHeaderCell>Station</Table.ColumnHeaderCell>
  </>
)

export const InstallationIdentityCells = ({ installation }: { installation: Installation }) => (
  <>
    <Table.Cell>
      <Text size="2" className="font-mono">
        #{installation.installation_id}
      </Text>
    </Table.Cell>
    <Table.Cell>
      <Text size="2">{installation.site?.name ?? '—'}</Text>
    </Table.Cell>
    <Table.Cell>
      <Text size="2">{installation.name ?? '—'}</Text>
    </Table.Cell>
  </>
)
